import React from "react"
import { observer } from 'mobx-react-lite';

import Button from '@vromo/ui/components/Button';
import { dataTestId } from "@vromo/models";
import { useIntegrationsActions, useIntegrationsNav, useIntegrationsPage } from "../hooks";




/** colection of buttons for the different actions available on integrations listing page */
export const RibbonActions = observer(() => {

    const { fetchIntegrations } = useIntegrationsActions()
    const { isLoading, availableNewIntegrations } = useIntegrationsPage()
    const { goToWindow } = useIntegrationsNav()


    return (
        <div>
            <Button
                onClick={fetchIntegrations}
                disabled={isLoading}
                style={{ marginRight: 10 }}
                data-testid={dataTestId.integration.refresh}
            >
                Refresh
            </Button>
            <Button
                onClick={() => goToWindow("add")}
                disabled={isLoading || availableNewIntegrations.length < 1}
                data-testid={dataTestId.integration.new}
            >
                Add New integration
            </Button>
        </div>
    )
})